import { Box, colors, Grid, Paper } from '@material-ui/core';
import { moneyFormat, rCellMain } from '../../common/helpers';
import PurchaseChart from '../charts/PurchaseChart';

export default function PurchaseDataBx({ row, theme, isRTL, height = 200 }) {
  const scolor = colors.deepPurple[400];
  const pcolor = colors.green[400];
  const dcolor = colors.orange[400];

  const totalPurchaseInvoiced = row?.totalPurchaseInvoiced || 0;
  const totalPurchaseDiscount = row?.totalPurchaseDiscount || 0;
  const totalPurchasePaid = row?.totalPurchasePaid || 0;
  const openingbalance = row?.openingbalance || 0;
  const purchase = totalPurchaseInvoiced - totalPurchaseDiscount;
  const balance =
    totalPurchaseInvoiced +
    openingbalance -
    totalPurchasePaid -
    totalPurchaseDiscount;

  return (
    <Paper style={{ height }}>
      <Grid container spacing={0}>
        <Grid item xs={5}>
          <PurchaseChart
            scolor={scolor}
            pcolor={pcolor}
            dcolor={dcolor}
            row={row}
            theme={theme}
            height={height}
          ></PurchaseChart>
        </Grid>
        <Grid item xs={7}>
          <Grid container spacing={1}>
            <Grid item xs={6} style={{ marginTop: 30 }}>
              {rCellMain(isRTL ? 'المشتريات' : 'Purchases', scolor)}
            </Grid>
            <Grid item xs={6} style={{ marginTop: 30 }}>
              {rCellMain(moneyFormat(purchase), scolor)}
            </Grid>
            <Grid item xs={6}>
              {rCellMain(
                isRTL ? 'الرصيد الافتتاحي' : 'Opening Balance',
                scolor
              )}
            </Grid>
            <Grid item xs={6}>
              {rCellMain(moneyFormat(openingbalance), scolor)}
            </Grid>
            <Grid item xs={6}>
              {rCellMain(isRTL ? 'المدفوعات' : 'Payments', pcolor)}
            </Grid>
            <Grid item xs={6}>
              {rCellMain(moneyFormat(totalPurchasePaid), pcolor)}
            </Grid>
            {/* <Grid item xs={6}>
              {rCellMain(isRTL ? 'الخصومات' : 'Discounts', dcolor)}
            </Grid>
            <Grid item xs={6}>
              {rCellMain(moneyFormat(totalPurchaseDiscount), dcolor)}
            </Grid> */}
            <Grid item xs={6}>
              <Box style={{ marginTop: 20 }}>
                {rCellMain(isRTL ? 'الرصيد' : 'Balance', '#333')}
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box style={{ marginTop: 20 }}>
                {rCellMain(moneyFormat(balance), '#333')}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}
